import _defineProperty from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/regenerator/index.js";
import { Markdown, MarkdownSize } from '@vtblife/react-markdown';
import { Button } from '@vtblife/uikit';
import { Form, Formik } from '@vtblife/uikit-formik';
import React, { useEffect, useRef, useState } from 'react';
import { createDependencyValidator } from '@vtblife/form-renderer-kit/dist/components/form-renderer/utils/create-dependency-validator';
import cn from 'classnames';
import { pick } from 'lodash';
import { getStepFieldName } from '../../utils/step-field';
import styles from './stepper-form.module.css';
import { StepsIndicator } from './steps-indicator';
import { handleSendStepError } from './utils/handle-send-step-error';
import { toDto } from './utils/to-dto';
import { useFormFieldsData } from './utils/use-form-fields-data';
import { sendQuizAnalytics } from '../../utils/quiz-analytics';
import { StepRender } from '../step-render/step-render';
export var StepperForm = function StepperForm(_ref) {
  var quizId = _ref.quizId,
    quizName = _ref.quizName,
    steps = _ref.steps,
    progressBar = _ref.progressBar,
    background = _ref.background,
    onLastStepSubmit = _ref.onLastStepSubmit,
    _onNextStep = _ref.onNextStep,
    setCurrentStep = _ref.setCurrentStep;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useFormFieldsData = useFormFieldsData({
      steps: steps
    }),
    fieldsValidators = _useFormFieldsData.fieldsValidators,
    fieldsMap = _useFormFieldsData.fieldsMap,
    initialValues = _useFormFieldsData.initialValues;
  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data, helpers) {
      var _toDto, fields;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            setLoading(true);
            _toDto = toDto(data, fieldsMap), fields = _toDto.fields;
            _context.next = 5;
            return onLastStepSubmit({
              formData: data,
              fields: fields
            });
          case 5:
            _context.next = 10;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            console.error(_context.t0);
          case 10:
            _context.prev = 10;
            setLoading(false);
            helpers.resetForm();
            return _context.finish(10);
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7, 10, 14]]);
    }));
    return function onSubmit(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  var onNextStep = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data) {
      var formData, lastStep, step, stepIndex, _toDto2, fields;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!_onNextStep) {
              _context2.next = 15;
              break;
            }
            _context2.prev = 1;
            formData = data.formData, lastStep = data.lastStep, step = data.step, stepIndex = data.stepIndex;
            setLoading(true);
            _toDto2 = toDto(pick(formData, [getStepFieldName(step)]), fieldsMap), fields = _toDto2.fields;
            _context2.next = 7;
            return _onNextStep === null || _onNextStep === void 0 ? void 0 : _onNextStep({
              formData: formData,
              lastStep: lastStep,
              step: step,
              stepIndex: stepIndex,
              fields: fields
            });
          case 7:
            _context2.next = 12;
            break;
          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](1);
            handleSendStepError(_context2.t0);
          case 12:
            _context2.prev = 12;
            setLoading(false);
            return _context2.finish(12);
          case 15:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 9, 12, 15]]);
    }));
    return function onNextStep(_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
  var validate = function validate(fieldsNames) {
    var errors = Object.entries(fieldsNames).reduce(function (acc, _ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
        name = _ref5[0],
        value = _ref5[1];
      acc[name] = fieldsValidators[name](value, fieldsNames);
      return acc;
    }, {});
    return JSON.parse(JSON.stringify(errors));
  };
  return React.createElement(Formik, {
    initialValues: initialValues,
    onSubmit: onSubmit,
    validate: validate,
    enableReinitialize: true,
    isInitialValid: false
  }, function (props) {
    return React.createElement(FormComponent, _objectSpread({
      quizId: quizId,
      quizName: quizName,
      loading: loading,
      onNextStep: onNextStep,
      steps: steps,
      progressBar: progressBar,
      background: background,
      setCurrentStep: setCurrentStep
    }, props));
  });
};
function filterSteps(_ref6) {
  var formValues = _ref6.formValues,
    steps = _ref6.steps;
  return steps.filter(function (step) {
    var validator = createDependencyValidator(step.condition);
    if (validator) {
      return validator(formValues);
    }
    return true;
  });
}
function FormComponent(_ref7) {
  var quizId = _ref7.quizId,
    quizName = _ref7.quizName,
    loading = _ref7.loading,
    _steps = _ref7.steps,
    formValues = _ref7.values,
    submitForm = _ref7.submitForm,
    setFieldValue = _ref7.setFieldValue,
    setFieldTouched = _ref7.setFieldTouched,
    initialValues = _ref7.initialValues,
    getFieldMeta = _ref7.getFieldMeta,
    validateForm = _ref7.validateForm,
    progressBar = _ref7.progressBar,
    background = _ref7.background,
    _onNextStep = _ref7.onNextStep,
    setCurrentStep = _ref7.setCurrentStep;
  var _useState3 = useState(function () {
      return {
        steps: filterSteps({
          steps: _steps,
          formValues: formValues
        }),
        currentStepIndex: 0
      };
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    state = _useState4[0],
    setState = _useState4[1];
  var formValuesRef = useRef();
  formValuesRef.current = formValues;
  useEffect(function () {
    setState({
      steps: filterSteps({
        steps: _steps,
        formValues: formValuesRef.current
      }),
      currentStepIndex: 0
    });
  }, [_steps]);
  useEffect(function () {
    validateForm();
  }, [validateForm]);
  var currentStepIndex = state.currentStepIndex,
    steps = state.steps;
  var currentStep = steps[currentStepIndex];
  var fieldMeta = getFieldMeta(getStepFieldName(currentStep));
  var isValid = !fieldMeta.error;
  var onNextStep = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var newSteps, newStepIndex, lastStep;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (fieldMeta.error) {
              _context3.next = 9;
              break;
            }
            newSteps = filterSteps({
              steps: _steps,
              formValues: formValues
            });
            newStepIndex = currentStepIndex + 1;
            lastStep = !newSteps[newStepIndex];
            setCurrentStep(function (prevStep) {
              return +prevStep + 1;
            });
            sendQuizAnalytics({
              quizName: quizName,
              quizId: quizId,
              quizStep: newStepIndex,
              quizChoice: formValues[getStepFieldName(currentStep)],
              quizAction: 'continue'
            });
            _context3.next = 8;
            return _onNextStep === null || _onNextStep === void 0 ? void 0 : _onNextStep({
              formData: formValues,
              lastStep: lastStep,
              step: currentStep,
              stepIndex: currentStepIndex
            });
          case 8:
            if (lastStep) {
              submitForm();
            } else {
              setState({
                currentStepIndex: newStepIndex,
                steps: newSteps
              });
            }
          case 9:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function onNextStep() {
      return _ref8.apply(this, arguments);
    };
  }();
  var prevStep = function prevStep() {
    setCurrentStep(function (prevStep) {
      return +prevStep - 1;
    });
    sendQuizAnalytics({
      quizName: quizName,
      quizId: quizId,
      quizStep: currentStepIndex + 1,
      quizAction: 'back'
    });
    setState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        currentStepIndex: prev.currentStepIndex - 1
      });
    });
    var fieldName = getStepFieldName(currentStep);
    setFieldValue(fieldName, initialValues[fieldName] || '');
    setFieldTouched(fieldName, false);
  };
  return React.createElement(Form, {
    className: styles.form
  }, React.createElement(StepsIndicator, {
    currentStepIndex: currentStepIndex,
    progressBar: progressBar,
    background: background,
    stepsLength: state.steps.length
  }), React.createElement("div", {
    className: styles.stepContainer
  }, currentStep.description && React.createElement("div", {
    className: styles.stepDescription
  }, React.createElement(Markdown, {
    startHeader: 3,
    source: currentStep.description,
    minimalHeadingStyleLevel: 3,
    sizeVariant: MarkdownSize.Quiz
  }), currentStep.type === 'checkbox-group' && React.createElement("div", {
    className: styles.stepFieldLabel
  }, "\u041C\u043E\u0436\u0435\u0442\u0435 \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u043E\u0432 \u043E\u0442\u0432\u0435\u0442\u0430")), React.createElement("div", {
    className: cn(styles.fieldWrapper, styles["field-".concat(currentStep.type)])
  }, React.createElement(StepRender, _objectSpread({}, currentStep)))), React.createElement("div", {
    className: styles.navigationButtons
  }, state.currentStepIndex > 0 && React.createElement("div", {
    className: styles.buttonPrev
  }, React.createElement("div", {
    className: styles.buttonPrevWithIcon
  }, React.createElement(Button, {
    onClick: prevStep,
    disabled: loading,
    size: "l",
    variant: "secondary",
    icon: "arrow-left"
  })), React.createElement("div", {
    className: styles.buttonPrevWithText
  }, React.createElement(Button, {
    onClick: prevStep,
    disabled: loading,
    size: "l",
    variant: "secondary",
    fullWidth: true
  }, "\u041D\u0430\u0437\u0430\u0434"))), React.createElement("div", {
    className: styles.buttonNext
  }, React.createElement(Button, {
    onClick: onNextStep,
    loading: loading,
    disabled: !isValid || loading,
    fullWidth: true,
    size: "l"
  }, "\u0414\u0430\u043B\u0435\u0435"))));
}